import React from 'react';
import { AppModal, AppButton, AppTypography } from '@/components/atoms';
import { formatJapaneseDate } from '@/utils';
import { useTheme } from '@shared/providers/theme/ThemeContext';

export interface InformationPreviewData {
  title: string;
  information_date: string;
  contents: string | null;
}

const nl2br = (text: string): string => text.replace(/\n/g, '<br>');

const HtmlContent: React.FC<{ html?: string | null; className?: string }> = ({
  html,
  className,
}) => {
  return <div className={className} dangerouslySetInnerHTML={{ __html: nl2br(html || '') }} />;
};

interface AdminInformationPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: InformationPreviewData | null;
}

const AdminInformationPreviewModal: React.FC<AdminInformationPreviewModalProps> = ({
  isOpen,
  onClose,
  data,
}) => {
  const { colors } = useTheme();

  if (!data) return null;

  return (
    <AppModal
      title="プレビュー"
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={766}
      closable={true}
      footer={() => (
        <AppButton
          onClick={onClose}
          icon={<i className="fa fa-close" aria-hidden="true" />}
          style={{
            borderColor: colors.primaryDark,
            color: colors.primaryDark,
          }}
          className="hover:!bg-gray-100 hover:!border-primaryDark hover:!text-primaryDark transition-colors"
        >
          閉じる
        </AppButton>
      )}
      styles={{
        body: {
          height: '500px',
          overflowY: 'auto',
        },
      }}
    >
      <div className="w-full space-y-3">
        <AppTypography.H4 className="!m-0 !text-[16pt]">
          <span dangerouslySetInnerHTML={{ __html: data.title }} />
          {' '}
          <AppTypography.Text
            type="secondary"
            className="!text-[11pt] font-normal whitespace-nowrap"
          >
            ({formatJapaneseDate(data.information_date)})
          </AppTypography.Text>
        </AppTypography.H4>
        <HtmlContent
          className="text-[11pt] whitespace-pre-line break-words overflow-hidden"
          html={data.contents}
        />
      </div>
    </AppModal>
  );
};

export default AdminInformationPreviewModal;
